import React, { Component } from 'react';
import { withRouter } from "react-router-dom";

import styled from 'styled-components'
import cssVar from '../styles/variables'
import { ScrollHint, ScrollHintIcon, ScrollHintText, HeroSectionText, HeroContentWrapper, FullSizeBackgroundVideo, SlimSection, Heading4, LinkText, FullAreaWrapper, PrimaryButton, SecondaryButton, Text, Link, withColor, Heading2, Heading3, BiggerText, H1, GridRow, FullWidthWrapper, Section, FullWidthSection, HeroSection, Heading1, MaxContentWidthContainer, MaxContentWidthWrapper } from '../components/marketing/MarketingStyles';

import PromotionVideo from '../components/marketing/PromotionVideoSection'
import Pricing from '../components/marketing/PricingSection'
import GolfCourseMap from '../components/marketing/GolfCourseMap'
import QandA from '../components/marketing/QandASection'
import CtaBox from '../components/marketing/CtaBox'

import Logo from '../images/logo.png'
import FlyOverArrow from '../images/icons/arrow-flyover.png'
import DiscoverMoreArrow from '../images/icons/arrow-discover-more.svg'

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import { inject, observer } from 'mobx-react'

import { trackEvent } from "../utils/eventTracking"

@inject('modalStore', 'utilStore')
@observer
class SummerSaleLandingPage extends Component {

   constructor(props) {
     super(props)
     this.state = {
       pressIndex: 1
     }
   }

  componentDidMount() {
  }

  render() {

    const Hero = ( ) => (
      <HeroSection>
        <FullSizeBackgroundVideo>
          <video loop="true" autoPlay="true" muted="true" playsInline="true">
            <source src="https://the-loge-data.fra1.digitaloceanspaces.com/marketing/videos/Hero-Section-Video-sommeraktion.mp4" type="video/mp4" />
          </video>
        </FullSizeBackgroundVideo>
        <MaxContentWidthWrapper style={{height: '100%'}}>
          <MaxContentWidthContainer style={{height: '100%'}}>
            <GridRow
              desktop="1fr 1fr"
              tablet="1fr"
              phone="1fr"
              style={{height: '100%'}}
            >
              <HeroContentWrapper>
                <H1 color="#FFFFFF">PLAY GOLF<br/>MAKE BUSINESS</H1>
                <HeroSectionText>
                  Das größte Golfnetzwerk einer neuen Generation von Unternehmern.
                </HeroSectionText>
                <GridRow
                  desktop="auto auto"
                  phone="1fr"
                  phoneRowGap
                >
                  <div>
                    <PrimaryButton value="Mehr Informationen anfordern" onClick={ () => { this.props.modalStore.setState('request_information', true); trackEvent( 'Request Information - Hero', 'Advertisment', 'Click Button' ) } } autoWidth />
                  </div>
                  {/* <div>
                    <SecondaryButton value="Mehr Infos" onClick={ () => { this.props.modalStore.setState('request_information', true); trackEvent( 'Request Information - Herosection', 'Advertisment', 'Click Button' ) }} autoWidth/>
                  </div> */}
                </GridRow>
              </HeroContentWrapper>
            </GridRow>
          </MaxContentWidthContainer>
        </MaxContentWidthWrapper>
        <ScrollHint onClick={ () => this.startOfPage.scrollIntoView()}>
          <ScrollHintText>Mehr Entdecken</ScrollHintText>
          <ScrollHintIcon src={ DiscoverMoreArrow } />
        </ScrollHint>
      </HeroSection>
    )

    const About = ( ) => (
      <Section id="about">
        <GridRow
          desktop="1fr 1fr"
          tablet="1fr"
        >
          <div>
            <h1><Heading1>THE LOGE -65% Herbstaktion</Heading1></h1>
            <BiggerText>
              Wie die Zeit vergeht. Jetzt ist schon der Herbst gekommen. Aber auch in der späteren Jahreszeit kann man in Österreich wunderbar Golf spielen. Deshalb gibt es ab September die THE LOGE Mitgliedschaft für 2022 zum stark reduzierten Sonderpreis. Das bedeutet, dass neue Mitglieder heuer noch ca. 30 Golfrunden über THE LOGE buchen können.<br />
            </BiggerText>
            <BiggerText>
              Die Mitgliedschaft für 2022 beträgt somit nur noch 770 Euro exkl. MwSt. Das Angebot gilt bis Ende Oktober. <br />
              Wie Ihr ja wisst: Nur Unternehmen können eine Mitgliedschaft zeichnen. Also für jeden Geschäftsführer oder Eigentümer ist dies für sein Unternehmen möglich.
            </BiggerText>
            <BiggerText>
              Mit 37 Golfplätzen und über 300 Unternehmen sind wir in Österreich schon zu einem sehr bedeutenden Firmen- Golf Netzwerk herangewachsen. <br />
            </BiggerText>
            <BiggerText>
              Wenn Ihr also golfaffine Unternehmer seid, dann seht Euch doch unsere Video an. Da findet Ihr in einem Video kurz zusammengefasst ganzen Infos. <br />
            </BiggerText>
            <BiggerText>
              Wir wünschen Euch einen schönen Herbst und viele Birdies :-)
            </BiggerText>
            <BiggerText>
              Tom & Gerry
            </BiggerText>
          </div>
        </GridRow>
      </Section>
    )

    const FlyOverCTA = () => (
      <FlyOver onClick={ () => { this.props.history.push('/bewerbung'); trackEvent( 'Apply - Sticky Badge', 'Application', 'Click Button' ) } }>
        <FlyOverIcon src={ FlyOverArrow } />
        <FlyOverLogo src={ Logo } />
        <FlyOverText>Bewerbung starten</FlyOverText>
      </FlyOver>
    )

    const GolfCourseMapSection = ( ) => (
      <GolfCourseMapWrapper>
        <GolfCourseMap showPanel={true} />
      </GolfCourseMapWrapper>
    )

    const ApplyCTA = ( ) => (
      <SlimSection>
        <CtaBox
          title="Jetzt Bewerbung starten"
          text="Jetzt die Bewerbung starten und in ein einzigartiges Netzwerk tauchen."
          buttonText="Jetzt Bewerben"
          buttonLink="/bewerbung"
          onClick={ () => trackEvent( 'Apply - Footer - CTA Section', 'Application', 'Click Button' )}
        />
      </SlimSection>
    )

    const HeadlineWithText = ({ style, title, text }) => (
      <MaxContentWidthWrapper style={ style }>
          <MaxContentWidthContainer>
            <GridRow
              desktop="1fr 1fr"
              tablet="1fr"
            >
              <div>
                <Heading1>{title}</Heading1>
                <BiggerText>{text}</BiggerText>
              </div>
            </GridRow>
          </MaxContentWidthContainer>
        </MaxContentWidthWrapper>
    )

    console.log('UTIL', this.props.utilStore.util.summer_sale_video);

    return (
      <FullWidthWrapper>
        {/* <Hero /> */}
        <div ref={ (ref) => this.startOfPage=ref }></div>
        <About />

        <HeadlineWithText title="Exklusive Firmen Mitgliedschaft" text="Erleben Sie wie Networking am Golfplatz funktioniert" />
        <PromotionVideo utilTarget="summer_sale_video" />
        
        <HeadlineWithText style={{ padding: '6em 0' }} title="Übersicht aller teilnehmenden Golfplätze im THE LOGE Network" text="37 Golfplätze davon 10 Leading Golf Courses machen Networking am Golfplatz zum Erlebnis" />
        <GolfCourseMapSection />

        <div ref={ (ref) => this.beforePricingSection=ref }></div>
        <Pricing />
        <ApplyCTA />
        <QandA />

        <FlyOverCTA />
      </FullWidthWrapper>
    )
  }
}

export default withRouter(SummerSaleLandingPage)

const GolfCourseMapWrapper = styled(FullWidthSection) `
  height: 800px;

  ${cssVar.breakpoints.tablet} {
    height: auto;
  }
`

const FlyOver = styled.div `
  background: ${ cssVar.colors.blue };
  height: 90px;
  border-radius: 45px 0 0 45px;
  position: fixed;
  right: 0;
  bottom: 50px;
  margin-right: -250px;
  transition: all ${ cssVar.transitions.basic };
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  box-shadow: rgba(0,0,0,0.2) 0 0 5px;

  :hover {
    margin-right: 0;
  }

  ${cssVar.breakpoints.tablet} {
    display: none;
  }
`

const FlyOverIcon = styled.img `
  width: 15px;
  margin: 20px;
  object-fit: contain;
`

const FlyOverLogo = styled.img `
  width: 90px;
  padding: 15px;
  margin-right: 10px;
`

const FlyOverText = styled.div `
  width: 250px;
  color: ${ cssVar.colors.gold };
  text-decoration: underline;
  text-transform: uppercase;
  text-align: center;
  font-family: 'Supreme-Regular';
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.03em;
`



// WEBPACK FOOTER //
// /src/pages/SummerSaleLandingPage.js